import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import GameInfoView from "@/views/game/GameInfoView.vue";
import { parseMoveIndicesToString } from "@/game_logic/utils/parseMove";
import { useGameStore } from "@/stores/gameStore";
import { storeToRefs } from "pinia";


export default /*#__PURE__*/_defineComponent({
  __name: 'GameInfoPresenter',
  setup(__props) {

const gameStore = useGameStore();
const { gameState: game, isAttackersTurn } = storeToRefs(gameStore);

const displayMoveHistory = computed(() =>
  game.value.moveHistory.map(([startRow, startColumn, endRow, endColumn]) =>
    parseMoveIndicesToString(startRow, startColumn, endRow, endColumn)
  )
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GameInfoView, {
    turn: _unref(game).turn,
    "move-history": _unref(displayMoveHistory),
    "is-attackers-turn": _unref(isAttackersTurn)
  }, null, 8, ["turn", "move-history", "is-attackers-turn"]))
}
}

})